<template>
  <div v-if="isLoggedIn" id="sidebar">
    <v-navigation-drawer
      app
      permanent
      v-model="mini"
      :mini-variant.sync="mini"
      width="200"
      hide-overlay
    >

      <v-flex style="cursor: pointer;" @click.stop="navigateTo('root')">
        <v-img class="mt-4 mx-auto" contain max-width="150" :src="require('../../images/vss_employee_logo.png')"></v-img>
      </v-flex>

      <EmployeeSidebar v-if="user.role == 'employee'" />
      <ClientSidebar v-if="user.role == 'client'" />
      <ManagerSidebar v-if="user.role == 'manager'" />
      <AdminSidebar v-if="user.role == 'boh' || user.role == 'superadmin'" />

      <div>
        <v-list>

          <v-list-tile @click.stop="navigateTo('profile')">
            <v-list-tile-action>
              <v-icon>account_circle</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              Profile
            </v-list-tile-content>
          </v-list-tile>

          <v-list-tile @click.stop="logout">
            <v-list-tile-action>
              <v-icon>power_settings_new</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              Logout
            </v-list-tile-content>
          </v-list-tile>

          <v-list-tile v-if="mini" @click.stop="mini = !mini">
            <v-list-tile-action>
              <v-icon>chevron_right</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile v-else @click.stop="mini = !mini">
            <v-list-tile-action>
              <v-icon>chevron_left</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
            </v-list-tile-content>
          </v-list-tile>

        </v-list>
      </div>

    </v-navigation-drawer>
  </div>
  <div v-else>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { mapGetters } from 'vuex'
import EmployeeSidebar from '@/components/base/employee-sidebar.vue'
import ClientSidebar from '@/components/base/client-sidebar.vue'
import ManagerSidebar from '@/components/base/manager-sidebar.vue'
import AdminSidebar from '@/components/base/admin-sidebar.vue'

export default {
  components: {
    EmployeeSidebar,
    ClientSidebar,
    ManagerSidebar,
    AdminSidebar,
  },
  computed: {
    ...mapState('userAuth', [
      'user',
      'token'
    ]),
    ...mapGetters('userAuth', [
      'isLoggedIn'
    ])
  },
  data: function () {
    return {
      mini: null,
    }
  },
  methods: {
    logout() {
      this.$store.dispatch('userAuth/logout')
    },
    navigateTo(routeName) {
      this.$router.push({ name: routeName })
    },
  }
}
</script>

<style scoped>
  #sidebar a {
    color: black;
    text-decoration: none;
  }
</style>
